/* Local dependencies */
import { Order, OrderStatus } from '../../../shared/types';

export enum ListOrdersActionTypes {
  LIST_ORDERS_REQUEST = 'LIST_ORDERS_REQUEST',
  LIST_ORDERS_SUCCESS = 'LIST_ORDERS_SUCCESS',
  LIST_ORDERS_ERROR = 'LIST_ORDERS_ERROR',
  RESET_ERROR = 'RESET_ERROR',
  RESET_STATE = 'RESET_STATE',
}

export interface ListOrdersFilter {
  statuses?: OrderStatus[];
  userId?: string;
  warehouseId?: string;
}

export interface ListOrdersRequest {
  type: ListOrdersActionTypes.LIST_ORDERS_REQUEST;
  query?: string;
  from?: number;
  filter?: ListOrdersFilter;
  size?: number;
  currentPage?: number;
}

export interface ListOrdersSuccess {
  type: ListOrdersActionTypes.LIST_ORDERS_SUCCESS;
  orders: Order[];
  total: number;
}

export interface ListOrdersError {
  type: ListOrdersActionTypes.LIST_ORDERS_ERROR;
  error: Error;
}

export interface ResetListOrdersError {
  type: ListOrdersActionTypes.RESET_ERROR;
}

export interface ResetListOrdersState {
  type: ListOrdersActionTypes.RESET_STATE;
}

export type ListOrdersAction =
  | ListOrdersRequest
  | ListOrdersSuccess
  | ListOrdersError
  | ResetListOrdersError
  | ResetListOrdersState;
